import { NextgenDOMPurify } from '@nextgen-web-framework/all';
import AudioPlayerContainer from '../AudioPlayer/AudioPlayer';
import styles from './ContentHeaderCard.module.scss';
import { type ContentHeaderCardProps } from './types/propsTypes';
const ContentHeaderCard = (props: ContentHeaderCardProps) => (
  <div className={`${styles['content-header-card-container']}`} data-testid={`content-header-card-container-testid`}>
    <div className={styles['content']}>
      <div className={styles['header']}>
        <div className={styles['tag']}>{props.tag}</div>
        {props.title && (
          <div className={styles['title']} title={props.title}>
            {props.title}
          </div>
        )}
      </div>
      {props.subTitle && (
        <div className={styles['footer']}> {<div className={styles['footer-line']}>{props.subTitle}</div>}</div>
      )}
      {props.description && (
        <div
          className={styles['description']}
          dangerouslySetInnerHTML={{
            __html: props.sanitize
              ? NextgenDOMPurify(props.description ?? '', props.sanitizationConfig)
              : props.description,
          }}
        />
      )}
    </div>
    {props?.audioFile?.audio_file.url && (
      <div className={styles['audio_player']}>
        <AudioPlayerContainer audio_file={props?.audioFile?.audio_file} componentType={'audio_player'} />
      </div>
    )}
  </div>
);

export default ContentHeaderCard;
